"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthListenerAddButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const constants_1 = require("@dzambalaorg/constants");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const EthListenerAddButton = (props) => {
    const { className, contract, disabled, variant } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { fn } = (0, react_hooks_1.useApiCall)(async (api, values) => {
        return api.fetchJson({
            url: "/eth-logger/add",
            method: "POST",
            data: values,
        });
    });
    const handleEthListenerAddConfirm = async ({ data }) => {
        await fn(void 0, data);
    };
    const handleEthListenerAdd = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ADD_ETH_LISTENER, contract, {
            initialValues: {
                address: contract.address,
                listenerType: (0, utils_1.getListenerType)(contract),
                fromBlock: contract.fromBlock,
                chainId: contract.chainId,
            },
            validationSchema: dialog_1.addEthListenerValidationSchema,
            message: "dialogs.listenerAdd",
            testId: "EthListenerAddForm",
            disabled: false,
            onExternalConfirm: handleEthListenerAddConfirm,
        });
    };
    if (process.env.NODE_ENV === constants_1.NodeEnv.production) {
        return null;
    }
    if (contract.contractType === types_1.TokenType.NATIVE) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleEthListenerAdd, icon: icons_material_1.DoNotDisturbOn, message: "form.buttons.addListener", className: className, dataTestId: "EthListenerAddButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }));
};
exports.EthListenerAddButton = EthListenerAddButton;
//# sourceMappingURL=index.js.map